/* Fiora Bloom - Mobile-Navigation, 31.08.2026, ergaenzt 01.09.2026.
   Neun eng umrissene Aufgaben, alle ausschliesslich im Menue-Drawer.
   assets/theme.js (302 KB Vendor) bleibt unberuehrt. */

(function () {
  var drawer = document.getElementById('menu-drawer');
  if (!drawer) return;

  var MAIN_ID = 'menu-drawer-panel-main';
  var mainPanel = drawer.querySelector('header-menu-drawer-panel[data-main-panel]');
  if (!mainPanel) return;

  /* Der aktive Panelzustand wird SELBST gefuehrt, nicht aus .is-visible
     abgeleitet: HeaderMenuDrawerPanel.hide() entfernt die Klasse erst im
     .then() seiner 400-ms-Animation. Waehrend eines Wechsels tragen also
     BEIDE Panels .is-visible - ein Blick auf die Klassen liefert dann das
     falsche Panel, und inert und aria-expanded landen verkehrt herum. */
  var currentPanelId = MAIN_ID;
  var resetScheduled = false;

  function panels() {
    return drawer.querySelectorAll('header-menu-drawer-panel');
  }

  /* 1 - Bilder im Drawer laden, GETRENNT NACH PANEL (C6, 01.09.2026).

     loading="lazy" greift hier nicht: .menu-drawer steht bis zum Oeffnen auf
     display:none, und fuer verborgene Elemente startet der Browser keinen
     Ladevorgang. Nachgemessen am 31.08.2026: bei geschlossenem Drawer sind
     0 von 14 Bildern geladen - der Mechanismus ist also nicht ueberfluessig,
     und global auf eager zu stellen waere Verschwendung auf jeder Seite.

     Bis 01.09.2026 wurden beim Antippen des Hamburgers ALLE Bilder
     angefordert, auch die zehn 40-px-Vorschauen von Ebene 2, die viele
     Kundinnen nie zu sehen bekommen. Jetzt holt das Oeffnen nur die zwei
     Linien-Kacheln des Hauptpanels; die Vorschauen kommen beim pointerdown
     auf den Panel-Umschalter, also rund 400 ms bevor das Panel steht.
     Gemessen am 01.09.2026: beim Oeffnen 2 statt 12 Bilder.

     KEIN Merker noetig: ein umgestelltes Bild traegt loading="eager" und
     faellt damit aus dem Selektor. Der Selektor ist die Idempotenz.

     WICHTIG: Die Anforderung haengt an pointerdown, nicht am Klick. Im
     Klick-Handler darf nichts laufen, was die Ereigniszustellung stoert -
     der Delegate des Themes haengt am selben Drawer (siehe Abschnitt 2). */
  function requestImagesIn(root) {
    if (!root) return;

    var images = root.querySelectorAll('img[loading="lazy"]');
    for (var i = 0; i < images.length; i++) {
      images[i].setAttribute('loading', 'eager');
      if (!images[i].complete) images[i].src = images[i].src;
    }
  }

  var triggers = document.querySelectorAll('[aria-controls="menu-drawer"]');
  for (var t = 0; t < triggers.length; t++) {
    triggers[t].addEventListener('pointerdown', function () {
      requestImagesIn(mainPanel);
    }, { once: true });
  }

  drawer.addEventListener('pointerdown', function (event) {
    if (!event.target || typeof event.target.closest !== 'function') return;

    var toggle = event.target.closest('[data-panel-toggle][aria-controls]');
    if (!toggle) return;

    var id = toggle.getAttribute('aria-controls');
    if (!id || id === MAIN_ID) return;

    requestImagesIn(document.getElementById(id));
  }, { passive: true });

  /* 2 - inert auf inaktiven Panels + aria-expanded auf den Umschaltern.
     Ohne inert bleibt das unsichtbare Panel per Tab erreichbar.
     syncState laeuft NIE synchron im Klick-Handler: inert nimmt einem
     Element waehrend der Ereigniszustellung die Ereignisfaehigkeit, und der
     Delegate des Themes haengt am selben Drawer. */
  function syncState() {
    var list = panels();

    for (var i = 0; i < list.length; i++) {
      if (list[i].id === currentPanelId) list[i].removeAttribute('inert');
      else list[i].setAttribute('inert', '');
    }

    var toggles = drawer.querySelectorAll('[data-panel-toggle][aria-controls]');
    for (var j = 0; j < toggles.length; j++) {
      var controls = toggles[j].getAttribute('aria-controls');
      if (controls === MAIN_ID) continue;
      toggles[j].setAttribute('aria-expanded', controls === currentPanelId ? 'true' : 'false');
    }
  }

  /* 3 - Panelzustand nach dem Schliessen zuruecksetzen.

     FEHLERBILD (gemeldet von Andreas, reproduziert am 31.08.2026):
     Drawer oeffnen, in "Alle Kategorien & Kollektionen" wechseln, Drawer
     schliessen, wieder oeffnen -> der Drawer war leer oder oeffnete auf
     Ebene 2, und der naechste Drill-down reagierte gar nicht mehr.

     Ausgeloest wird das ueber das open-Attribut des Drawers, nicht ueber
     dialog:after-hide - der Observer feuert zuverlaessig, das Event nicht
     in jedem Abbruchfall. resetScheduled verhindert die Schleife, die sonst
     entsteht, weil resetToMain selbst Klassen aendert und den Observer
     erneut ausloest. */
  function clearInlineStyles() {
    var list = panels();
    for (var i = 0; i < list.length; i++) list[i].removeAttribute('style');
  }

  function resetToMain() {
    currentPanelId = MAIN_ID;

    var list = panels();
    for (var i = 0; i < list.length; i++) {
      list[i].removeAttribute('style');
      if (list[i] === mainPanel) list[i].classList.add('is-visible');
      else list[i].classList.remove('is-visible');

      var body = list[i].querySelector('.menu-drawer__panel-body');
      if (body) body.scrollTop = 0;
    }
    syncState();
  }

  function healIfBlank() {
    var list = panels();
    for (var i = 0; i < list.length; i++) {
      if (list[i].classList.contains('is-visible')) return;
    }

    var target = document.getElementById(currentPanelId) || mainPanel;
    target.removeAttribute('style');
    target.classList.add('is-visible');
  }

  drawer.addEventListener('dialog:before-show', clearInlineStyles);

  if (typeof MutationObserver === 'function') {
    var observer = new MutationObserver(function () {
      if (drawer.hasAttribute('open')) {
        resetScheduled = false;
        requestImagesIn(mainPanel);
        healIfBlank();
        return;
      }

      if (resetScheduled) return;
      resetScheduled = true;
      window.setTimeout(resetToMain, 0);
    });

    var watched = panels();
    for (var k = 0; k < watched.length; k++) {
      observer.observe(watched[k], { attributes: true, attributeFilter: ['class'] });
    }
    observer.observe(drawer, { attributes: true, attributeFilter: ['open'] });
  }

  syncState();

  /* 4 - Fokus beim Panelwechsel, plus Notbremse.
     Es wird bewusst KEIN tabindex gesetzt: die Zielelemente (.back-button
     und der oeffnende Button) sind native <button> und ohnehin
     fokussierbar. Ein dauerhaftes tabindex="-1" haette den Zurueck-Button
     aus der Tab-Reihenfolge genommen - den einzigen Ausstieg per Tastatur.

     Notbremse: hat das Zielpanel nach Ablauf der Animation kein
     .is-visible, hat der Vendor nicht geschaltet. Dann wird ohne Animation
     umgeschaltet, damit das Menue in keinem Fall tot ist. */
  var openerButton = null;

  drawer.addEventListener('click', function (event) {
    if (!event.target || typeof event.target.closest !== 'function') return;

    var toggle = event.target.closest('[data-panel-toggle]');
    if (!toggle) return;

    var targetId = toggle.getAttribute('aria-controls');
    var panel = targetId ? document.getElementById(targetId) : null;
    if (!panel) return;

    var goingBack = targetId === MAIN_ID;
    var returnTo = openerButton;
    if (!goingBack) openerButton = toggle;

    currentPanelId = targetId;

    window.setTimeout(function () {
      if (!panel.classList.contains('is-visible')) {
        var list = panels();
        for (var i = 0; i < list.length; i++) {
          list[i].removeAttribute('style');
          if (list[i] === panel) list[i].classList.add('is-visible');
          else list[i].classList.remove('is-visible');
        }
      }

      if (panel.style.opacity === '0') panel.style.opacity = '';

      syncState();

      var target = goingBack
        ? (returnTo && drawer.contains(returnTo) ? returnTo : null)
        : panel.querySelector('.back-button');

      if (!target) return;
      try {
        target.focus({ preventScroll: true });
      } catch (error) {
        target.focus();
      }
    }, 420);
  });

  /* 5 - Suchzeile: den Menue-Drawer schliessen, damit nicht zwei Overlays
     uebereinander liegen. Wirkungslos, solange show_search in
     snippets/fiora-drawer-extras.liquid auf false steht. */
  var searchLink = drawer.querySelector('.fiora-nav__search');
  if (searchLink) {
    searchLink.addEventListener('click', function () {
      window.setTimeout(function () {
        if (typeof drawer.hide === 'function') drawer.hide();
      }, 60);
    });
  }

  /* 6 - Press-States auf iOS freischalten (I1, 01.09.2026).
     Mobile Safari wertet :active nur aus, wenn auf dem Element oder einem
     Vorfahren ein touch-Listener registriert ist. Ein leerer Listener
     genuegt. Er haengt bewusst an #menu-drawer und NICHT an body: dort
     kostet er auf jeder Seite Scroll-Leistung, hier nur im Drawer.
     passive: true, damit er das Scrollen im Panel nicht blockiert.
     Das Styling steht in assets/fiora-nav.css, Abschnitt 11. */
  drawer.addEventListener('touchstart', function () {}, { passive: true });

  /* 7 - Ladezustand bei Navigation aus dem Drawer (I2, 01.09.2026).

     BEFUND: layout/theme.liquid rendert <loading-bar>, theme.css stylt sie
     vollstaendig (2-3 px, schwarz, z-index 2000), und LoadingBar in
     theme.js hoert per document.addEventListener("theme:loading:start").
     Fuenf Vendor-Dispatches existieren - Warenkorb, Facetten, cart/add.js,
     Quick-Buy und Predictive Search - aber KEINER bei einer
     Link-Navigation. Es fehlte ausschliesslich der Dispatch.

     Zwei Details, die kein Beiwerk sind:

     (a) Die Verzoegerung von 140 ms. Ohne sie blitzt der Balken bei
         schneller Navigation kurz auf und verschwindet wieder - das liest
         sich wie ein Fehler, nicht wie eine Antwort. Der Timer stirbt beim
         Entladen der Seite ohnehin.

     (b) pageshow mit event.persisted. Kehrt die Kundin per Zurueck-Taste
         aus dem bfcache zurueck, wird die Seite im gemalten Zustand
         wiederhergestellt - der Balken haengt dann bei 40 %.

     Der Footer ist ausgenommen: dort sitzen Sprachwaehler und Kontolink,
     die teils per Formular arbeiten statt zu navigieren.

     bubbles ist zwingend: der Dispatch geht auf documentElement, gehoert
     wird auf document. Das ist wortgleich das Vendor-Idiom. */
  var loadingTimer = null;

  function dispatchLoading(name) {
    try {
      document.documentElement.dispatchEvent(new CustomEvent(name, { bubbles: true }));
    } catch (error) {
      /* Ohne CustomEvent eben kein Balken - kein Grund, die Navigation zu stoeren. */
    }
  }

  function cancelLoading() {
    if (loadingTimer === null) return;
    window.clearTimeout(loadingTimer);
    loadingTimer = null;
  }

  drawer.addEventListener('click', function (event) {
    if (event.defaultPrevented) return;
    if (event.button && event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!event.target || typeof event.target.closest !== 'function') return;

    var link = event.target.closest('a[href]');
    if (!link || !drawer.contains(link)) return;
    if (link.hasAttribute('download')) return;
    if (link.classList.contains('fiora-nav__search')) return;
    if (link.closest('.menu-drawer__panel-footer')) return;

    var linkTarget = link.getAttribute('target');
    if (linkTarget && linkTarget !== '_self') return;
    if (link.protocol !== 'http:' && link.protocol !== 'https:') return;
    if (link.host !== window.location.host) return;

    /* Reiner Ankersprung auf derselben Seite - es wird nichts geladen. */
    if (link.hash && link.pathname === window.location.pathname && link.search === window.location.search) return;

    cancelLoading();
    loadingTimer = window.setTimeout(function () {
      loadingTimer = null;
      dispatchLoading('theme:loading:start');
    }, 140);
  });

  window.addEventListener('pageshow', function (event) {
    cancelLoading();
    if (event.persisted) dispatchLoading('theme:loading:end');
  });

  /* 8 - Die erste Eingabe beendet den Auftritt (I3, 01.09.2026).

     BEFUND, gemessen: HeaderMenuDrawerPanel.show({initial:true}) staffelt
     die direkten Kinder von .menu-drawer__panel-body mit
     stagger(.1, {startDelay:.4}) bei duration:.2. Das Hauptpanel hat genau
     vier direkte Kinder, dazu kommt der Footer. Daraus ergeben sich
     Verzoegerungen von 0,40 / 0,50 / 0,60 / 0,70 s - die Linien-Kacheln
     stehen bei 0,60 s, das letzte Element bei 0,90 s.

     Wer den Hamburger antippt, hat ein Ziel. Beruehrt sie die Oberflaeche,
     steht das Menue sofort fertig da; wer nicht antippt, sieht die
     Choreografie zu Ende.

     BEWUSST NUR die Body-Kinder und der Footer, NICHT das Panel selbst.
     Der Panelwechsel - Slide von rechts ueber 400 ms, Rueckzug des
     Hauptpanels auf translateX(-30%) mit Schleier - traegt Bedeutung:
     Richtung zeigt Hierarchie, der Schleier zeigt, was zurueckliegt. Die
     Staffelung ist die einzige Bewegung im Drawer ohne Bedeutung.

     Fehlt getAnimations, passiert nichts - der Zustand von vor dem
     01.09.2026. Motion One animiert mit fill: both, finish() schreibt also
     den Endzustand fest. */
  function finishIntro() {
    var body = mainPanel.querySelector('.menu-drawer__panel-body');
    var nodes = body ? [].slice.call(body.children) : [];
    var footer = mainPanel.querySelector('.menu-drawer__panel-footer');
    if (footer) nodes.push(footer);

    for (var i = 0; i < nodes.length; i++) {
      if (typeof nodes[i].getAnimations !== 'function') return;

      var running = nodes[i].getAnimations();
      for (var j = 0; j < running.length; j++) {
        /* Beendete ueberspringen. Die Vendor-Animationen sammeln sich an:
           Motion One legt pro Oeffnung zwei je Element an, und eine beendete
           Animation mit fill: both bleibt "relevant", bis eine neuere sie
           ueberdeckt und die automatische Entfernung greift. Nach einigen
           Oeffnungen stehen hier zweistellige Zahlen.

           Das ist NICHT von diesem Abschnitt verursacht - die zwei
           Animationen entstehen mit und ohne I3, wir aendern nur den
           Zeitpunkt ihres Endes. Nachgemessen am 01.09.2026 im Preview, wo
           die Zeitachse stillsteht und die Entfernung deshalb nie greift.
           Es gibt trotzdem keinen Grund, bei jedem pointerdown erneut
           darueber zu laufen. */
        if (running[j].playState === 'finished') continue;

        try {
          running[j].finish();
        } catch (error) {
          /* Unendliche Animation - die gehoert uns nicht, also stehen lassen. */
        }
      }
    }
  }

  drawer.addEventListener('pointerdown', finishIntro, { passive: true });

  var mainBody = mainPanel.querySelector('.menu-drawer__panel-body');
  if (mainBody) mainBody.addEventListener('scroll', finishIntro, { passive: true });
})();